<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.613 13.172">
    <g id="Group_3534" data-name="Group 3534" transform="translate(0.5 0.5)">
      <path
        id="Path_1145"
        data-name="Path 1145"
        d="M-1020.3-2659.842v9.261l-2.922-2.272"
        transform="translate(1026.605 2660.59)"
        fill="none"
        stroke="#4a4a4a"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <path
        id="Path_1146"
        data-name="Path 1146"
        d="M-1019.5-2648.744l3.095-2.513"
        transform="translate(1025.809 2658.753)"
        fill="none"
        stroke="#4a4a4a"
        stroke-linecap="round"
        stroke-width="1" />
      <path
        id="Path_1147"
        data-name="Path 1147"
        d="M-1023.234-2650.407h-4.3v12.172h12.613v-12.172h-4.37"
        transform="translate(1027.536 2650.407)"
        fill="none"
        stroke="#4a4a4a"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
    </g>
  </svg>
</template>
